import { StudioState } from '../../types/store';
import { updateSelectedFolder } from '../../actions/studio/folders';

export const handleSetIsBusy = (state: StudioState, action): StudioState => ({
  ...state,
  folders: {
    ...state.folders,
    status: action.payload.isBusy ? 'busy' : 'idle',
  },
});

export const handleUpdateSelectedFolder = (
  state: StudioState,
  action: ReturnType<typeof updateSelectedFolder>
): StudioState => ({
  ...state,
  selectedFolder: action.payload.folder,
});
